export const adminEventAdditionalInstructionTranslations = (params: { eventId: number }) => `event:${params.eventId}`;
